import { useFeatureFlag, User } from 'configcat-react';

type FeatureFlagProps = {
  featureKey: string;
  defaultValue: boolean;
};

export const useGetFeatureFlag = (
  featureKey: FeatureFlagProps['featureKey'],
  defaultValue: FeatureFlagProps['defaultValue'],
  resellerId?: string,
) => {
  if (resellerId) {
    const userIdentifier = new User(resellerId);

    const { value, loading } = useFeatureFlag(featureKey, defaultValue, userIdentifier);

    return {
      value,
      loading,
    };
  }

  const { value, loading } = useFeatureFlag(featureKey, defaultValue);
  return {
    value,
    loading,
  };
};
